import React from 'react';
import style from './style.module.scss';

interface Props {
    text: React.ReactNode;
    hasError?: boolean;
    className?: string;
}

export const ErrorAwareLabel = ({ text, hasError, className }: Props) => {
    return (
        <span
            className={`body_regular ${hasError ? style.has_error : ''} ${
                className ?? ''
            }`}
        >
            {text}
        </span>
    );
};
